import React from 'react'

const Subjects = ({subject}) => {
  return (
    <div>
        <div className='text-gray-lessonGray py-[8px] font-[400] rounded-[11px] px-[10px] bg-gray-subjectGray text-[14px] whitespace-nowrap'>{subject || '⚗️ Chemistry#'}</div>
    </div>
  )
}

export default Subjects